<pk-broker-modal>
	<ng-template #headerTemplate>
		<h5 class="modal-title">Introducing Advisor Academy</h5>
	</ng-template>
	<ng-template #bodyTemplate>
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 pt-3">
					<div id="featureTourCarousel" class="carousel slide feature-tour-carousel" data-ride="carousel" data-interval="false">
						<div class="carousel-inner">
							<div class="carousel-item" *ngFor="let slide of featureTour.slides; let i = index" [class.active]="i === activeIndex">
								<img [src]="slide.imgSrc" class="d-block w-100" [attr.alt]="slide.name" />
								<div class="carousel-caption">
									<p class="font-size-1">{{ slide.caption }}</p>
								</div>
							</div>
						</div>
						<a class="carousel-control-prev" href="javascript:void(0)" (click)="previous()" role="button">
							<span class="carousel-control-prev-icon" aria-hidden="true"></span>
							<span class="sr-only">Previous</span>
						</a>
						<a class="carousel-control-next" href="javascript:void(0)" (click)="next()" role="button">
							<span class="carousel-control-next-icon" aria-hidden="true"></span>
							<span class="sr-only">Next</span>
						</a>
						<ol class="carousel-indicators">
							<li *ngFor="let slide of featureTour.slides; let i = index" [class.active]="i === activeIndex" (click)="activeIndex = i"></li>
						</ol>

						<div class="row d-flex justify-content-center my-2">
							<div class="col-auto">
								<button type="button" class="btn btn-secondary" (click)="goToAdvisorAcademy()">Explore Advisor Academy</button>
							</div>
						</div>
						<div class="row d-flex justify-content-center" *ngIf="tourModalState">
							<div class="col-auto form-element-container pb-0">
								<div class="custom-control custom-checkbox">
									<input type="checkbox" class="custom-control-input" id="dontShowAgainCheck" [(ngModel)]="tourModalState.dontShowAgainCheck" />
									<label class="custom-control-label" for="dontShowAgainCheck">Don't show again</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</pk-broker-modal>
